exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2cec51a8]:deep(iframe){display:block}", ""]);

// exports
